import React, { Fragment, useState } from 'react';
import PropTypes from 'prop-types';
import c from 'classnames';
import { ArrowBack } from '@material-ui/icons';
import { Helmet } from 'react-helmet';

import { cloneDeep } from 'lodash';
import AuthStore from '../../../common/AuthStore';
import ActiveFilters1 from '../assets/ActiveFilters1.svg';
import FilterSvg from '../assets/Filter.svg';
import LeftBuActive from '../assets/LeftBuActive.svg';
import RightBu from '../assets/RightBu.svg';
import DownloadIcon from '../assets/Download.svg';
import { getStaticText } from '../../../utils/constants';
import {
    getBenchmarkName,
    getBenchmarkString,
    resolveEntireOrganizationComparisonLabel,
} from '../../../utils/functions';
import colors from '../../../sass/colors';
import ErrorToast from '../../../components/InformationToast/ErrorToast';
import DwnldModal from '../../../components/InformationToast/DwnldModal';
import { getBuComparisonLabel } from '../IndExperienceBoard/indExperiencePublicSector';

function BUDetailedReport({
    setReport,
    scoreData,
    errorInfo,
    updateFilterView,
    activeResetFilter,
    defaultSettings,
    appliedFiltersInfo,
    localPractice,
    filters,
    buFilters,
    apiParams,
    getReport,
    getRawPptData,
    getSinglePastReport,
    singlePastReport,
    reportError,
    isEntireOrganizationSelected,
}) {
    const {
        quartileColors,
        report_name_or_client_name: rName = '',
        lang,
        survey_version,
        report_type = '',
        report_id = '',
        demographic = '',
        checkme_mapping = {},
        is_public_sector_ohi = false,
    } = defaultSettings;
    /** API may send quartile as string; quartileColors is indexed by number (e.g. top decile = 0). */
    const quartileKey = raw => {
        if (raw === '' || raw === undefined || raw === null) return raw;
        if (typeof raw === 'number' && Number.isFinite(raw)) return raw;
        const n = Number(String(raw).trim());
        return Number.isNaN(n) ? raw : n;
    };
    const staticText = getStaticText(lang);
    const { SITE_TEXT, ING_REPORT_ID, SINGLE_PAGE_EXPORT_PARAMS } = staticText;
    // const isOhi4 = survey_version === '4' || survey_version === '3_2';
    const { $white, $black, $siteTextColor } = colors;
    const { ohid: oldId, year: oldYear, threshold } = apiParams;
    const [dwnld, setdwnld] = useState(false);
    const {
        BU_HEAD,
        UNIT_HEAD,
        SCORECARD,
        FILTERS,
        BENCHMARK_HEAD,
        DIFF_HEAD,
        DOWNLOAD,
        SIGNIFICANCE,
        SIGNIFICANCES,
        HEALTH_BU_DETAILED_BOARD,
        HEALTH_UNIT_DETAILED_BOARD,
        PERCENT_FAVORABLE,
        PERCENTILES,
        COMPARISON_GROUP,
        MAIN_GROUP,
        ENTIRE_ORGANIZATION,
        ORGANIZATION,
        BOTTOM_DECILE,
        NO_BENCHMARK,
    } = SITE_TEXT || {};
    const buHead = getBuComparisonLabel(is_public_sector_ohi, BU_HEAD, UNIT_HEAD);
    const healthBuDetailedBoard = getBuComparisonLabel(
        is_public_sector_ohi,
        HEALTH_BU_DETAILED_BOARD,
        HEALTH_UNIT_DETAILED_BOARD
    );
    const practiceBuName = resolveEntireOrganizationComparisonLabel(AuthStore.practiceBU || COMPARISON_GROUP, {
        isEntireOrganizationSelected,
        entireOrganizationLabel: ENTIRE_ORGANIZATION,
        organizationLabel: ORGANIZATION,
    });
    const practiceReportName = AuthStore.practiceReportBU || MAIN_GROUP;
    const buHeadTitle = [`${practiceReportName} Score`, `${practiceBuName} Health Score`, DIFF_HEAD];
    const { buName = '' } = AuthStore;
    const { records = {} } = scoreData;
    const { ohi_score = {}, ...dataToIterate } = records;
    const {
        score: ohiScore = [],
        difference: ohiDiff = [],
        quartile: ohiQuartile = [],
        significance: ohiSign = [],
    } = ohi_score;
    const headerContent = [...ohiScore, ohiDiff[1]];
    const surveyV = survey_version === '4' || survey_version === '3_2';
    const isIngClient = String(report_id) === ING_REPORT_ID;

    const getSinglePageMeta = () => {
        const { bu_report = [] } = checkme_mapping || {};
        const defaultPage = cloneDeep([
            ...bu_report,
            'outcome_profile_bu_checkme',
            'practice_profile_bu_checkme_4_0',
            'practice_profile_bu_checkme',
        ]);
        return defaultPage;
    };

    const buPayload = newFilters => {
        const filtersArray = [];
        const { demographics = [], benchmarks: oldBench = [] } = newFilters[0];
        const { demographics: buDemo = [] } = newFilters[1] || {};
        demographics.forEach(({ options = [], code: parentCode = '' }, indexInDemo) => {
            const optionsCode = options
                .filter(({ isSelected }) => isSelected)
                .reduce((pre, { code }) => [...pre, code], []);
            const { options: buOptions = [] } = buDemo[indexInDemo] || {};
            const buOptionsCode = buOptions
                .filter(({ isSelected }) => isSelected)
                .reduce((pre, { code }) => [...pre, code], []);
            const preStr = optionsCode.length ? `${parentCode}:${optionsCode.join(',')}` : '';
            const endStr = buOptionsCode.length ? `${parentCode}:${buOptionsCode.join(',')}` : '';
            if (preStr || endStr) {
                filtersArray.push(`${preStr}||${endStr}`);
            }
        });
        return {
            ohid: `${oldId},${oldId}`,
            lang: parseInt(lang, 10),
            year: oldYear,
            threshold,
            filters: filtersArray,
            benchmark_str: getBenchmarkString(oldBench),
        };
    };

    const v4PptDownloadBu = () => {
        const addOns = {
            fill_threshold_with: demographic === '1' ? '-' : '',
            others: demographic === '3' ? 1 : 0,
        };
        const { benchmark = [] } = filters[0];
        const label = getBenchmarkName(benchmark);
        const singlePageParams = SINGLE_PAGE_EXPORT_PARAMS({ BENCHMARK_NAME: label });
        const valueToSend = {
            ...singlePageParams,
            ...addOns,
            report_name: rName,
            // report_name,
            bu_comparison_names: buName || COMPARISON_GROUP,
            ...apiParams,
            ...buPayload([filters[0], { demographics: buFilters }]),
            need_tornado_chart: false,
            report_id,
            single_page_meta: {
                checkme: getSinglePageMeta(),
                name: 'BU scorecard',
            },
            options: {
                ...singlePageParams.options,
                ...(apiParams.options || {}),
                org_level_filter: isEntireOrganizationSelected,
            },
        };
        setdwnld(true);
        getReport(valueToSend);
    };

    return (
        <>
            <div className="scoreBoard reSurveyReportBoard buDetailBoard clearfix" data-testid="buDetailBoardContent">
                <Helmet>
                    <title>{healthBuDetailedBoard}</title>
                </Helmet>
                <div className="breadCrumb">
                    <span data-testid="setScoreFromBuDetailBtn" onClick={() => setReport(0)}>
                        {SCORECARD}
                    </span>{' '}
                    / {buHead}
                </div>
                <h2 className="clearfix">
                    <span data-testid="setBackFromBuDetailBtn" onClick={() => setReport(0)}>
                        <ArrowBack />
                        {buHead}
                    </span>
                    <ul className="rightSideNav">
                        <li>
                            <span className="active">
                                <img src={LeftBuActive} alt="" />
                            </span>
                            <span data-testid="setBuNormalReportBtn" onClick={() => setReport(3)}>
                                <img src={RightBu} alt="" />
                            </span>
                        </li>
                        {!errorInfo && (
                            <li data-testid="getPptButton" onClick={v4PptDownloadBu}>
                                <img src={DownloadIcon} alt="" /> {DOWNLOAD}
                            </li>
                        )}

                        {dwnld && !reportError && (
                            <DwnldModal
                                getRawPptData={getRawPptData}
                                reportId={report_id}
                                open={dwnld}
                                setOpen={setdwnld}
                                getSinglePastReport={getSinglePastReport}
                                singlePastReport={singlePastReport}
                                defaultSettings={defaultSettings}
                            />
                        )}
                        <li data-testid="buDetailedFilterBtn" onClick={() => updateFilterView(true)}>
                            <img src={activeResetFilter ? ActiveFilters1 : FilterSvg} alt="" />
                            {FILTERS}
                        </li>
                    </ul>
                </h2>
                {errorInfo && <ErrorToast message={errorInfo} />}
                {Object.keys(scoreData).length ? (
                    <Fragment>
                        {appliedFiltersInfo()}
                        <ul className="headContent buHead">
                            {headerContent.map((headData, indexHead) => {
                                const qHead = ohiQuartile[indexHead];
                                const { background = $white, color = $siteTextColor, border: borderColor = $white } =
                                    quartileColors[quartileKey(qHead)] || {};
                                const { bg: secondBg = $white } = surveyV
                                    ? SIGNIFICANCES[ohiSign[1]] || {}
                                    : SIGNIFICANCE[ohiSign[1]] || {};
                                const headBg = indexHead === 2 ? secondBg : 'none';
                                /** Do not use truthiness on qHead — top decile is 0. */
                                const qEmpty = qHead === '' || qHead === undefined || qHead === null;
                                /** Hard color stops (no shared 5%/5% stop) avoid a hairline seam between wedge and fill. */
                                const dogEarBg = `linear-gradient(135deg, ${borderColor} 0%, ${borderColor} 5%, ${background} 5%, ${background} 100%)`;
                                const liStyle =
                                    indexHead < 2
                                        ? surveyV
                                            ? {
                                                  background: dogEarBg,
                                                  color,
                                                  border: 'none',
                                                  borderColor: 'transparent',
                                                  borderStyle: 'none',
                                                  boxShadow: '0 2px 5px 0 rgba(0, 0, 0, 0.17)',
                                              }
                                            : {
                                                  background,
                                                  color,
                                                  borderColor,
                                                  borderWidth: qEmpty ? 1 : 2,
                                                  borderStyle: 'solid',
                                              }
                                        : { background, color, borderColor };

                                return (
                                    <li style={liStyle} key={indexHead}>
                                        <h3 style={{ background: headBg }}>{headData}</h3>
                                        {buHeadTitle[indexHead]}
                                    </li>
                                );
                            })}
                        </ul>
                        <div className="detailReportHeader clearfix">
                            <div>{practiceReportName}</div>
                            <div>{practiceBuName}</div>
                            <div>{DIFF_HEAD}</div>
                        </div>
                        <div className="detailReport clearfix">
                            {Object.keys(dataToIterate).map(dataSet => {
                                const {
                                    display_name = '',
                                    score = [],
                                    children = {},
                                    quartile = [],
                                    difference = [],
                                    significance = [],
                                } = dataToIterate[dataSet];
                                const { bg = $white, borderWidth = 0 } = surveyV
                                    ? SIGNIFICANCES[significance[1]] || {}
                                    : SIGNIFICANCE[significance[1]] || {};
                                return (
                                    <section key={dataSet} className="reportTable clearfix">
                                        <div className="reportRow clearfix">
                                            <h4 className="ellipsisPro">{display_name}</h4>
                                            {score.map((scoreCont, indexScore) => {
                                                const { background = $white, border: borderColor = $white } =
                                                    quartileColors[quartileKey(quartile[indexScore])] || {};
                                                return (
                                                    <div className="scoreContent" key={indexScore}>
                                                        <div className="rank">
                                                            <div
                                                                className="textBorder"
                                                                style={{
                                                                    background,
                                                                    borderColor,
                                                                    borderWidth:
                                                                        quartile[indexScore] !== '' ||
                                                                        quartile[indexScore] === 999
                                                                            ? 2
                                                                            : 0,
                                                                    width: `${Math.abs(scoreCont)}%`,
                                                                }}
                                                            >
                                                                <div className="textRank">{scoreCont}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                );
                                            })}
                                            <div className="rankContent">
                                                <div className={c('rank', { negative: difference[1] < 0 })}>
                                                    <div
                                                        className="textBorder"
                                                        style={{
                                                            borderWidth,
                                                            background: bg,
                                                            width: `${Math.abs(difference[1])}%`,
                                                        }}
                                                    >
                                                        <div className="textRank">{difference[1]}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {Object.keys(children).map(childSet => {
                                            const {
                                                display_name: childName = '',
                                                score: childScore = [],
                                                quartile: childQuat = [],
                                                difference: childDiff = [],
                                                significance: childSign = [],
                                            } = children[childSet];
                                            const { bg: cbg = $white, borderWidth: cbw = 0 } = surveyV
                                                ? SIGNIFICANCES[childSign[1]] || {}
                                                : SIGNIFICANCE[childSign[1]] || {};
                                            return (
                                                <div key={childName} className="reportRow clearfix">
                                                    <h5 className="ellipsisPro">{childName}</h5>
                                                    {childScore.map((childScData, cSIn) => {
                                                        const { background: bgCh = $white, border: bdCh = $black } =
                                                            quartileColors[quartileKey(childQuat[cSIn])] || {};
                                                        return (
                                                            <div className="scoreContent" key={cSIn}>
                                                                <div className="rank">
                                                                    <div
                                                                        className="textBorder"
                                                                        style={{
                                                                            background: bgCh,
                                                                            borderColor: bdCh,
                                                                            borderWidth: childQuat[cSIn] !== '' ? 2 : 0,
                                                                            width: `${Math.abs(childScData)}%`,
                                                                        }}
                                                                    >
                                                                        <div className="textRank">{childScData}</div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        );
                                                    })}
                                                    <div className="rankContent">
                                                        <div className={c('rank', { negative: childDiff[1] < 0 })}>
                                                            <div
                                                                className="textBorder"
                                                                style={{
                                                                    background: cbg,
                                                                    borderWidth: cbw,
                                                                    width: `${Math.abs(childDiff[1])}%`,
                                                                }}
                                                            >
                                                                <div className="textRank">{childDiff[1]}</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </section>
                                );
                            })}
                        </div>
                        {isIngClient ? (
                            <div>
                                <div>{localPractice}</div>
                            </div>
                        ) : null}
                        {/* <ul className="benchmark clearfix fixedScoreCard">
                        <li>{BENCHMARK_HEAD} : </li>
                        {quartileColors.map(({ title, background, border: borderColor }) => (
                            <li key={title} style={{ color: background }}>
                                <span style={{ background, borderColor }} />
                                {title}
                            </li>
                        ))}
                    </ul> */}

                        {surveyV && (
                            <div>
                                {report_type === 'percent favorable' && (
                                    <div>
                                        <b>Note : </b> {PERCENT_FAVORABLE}
                                    </div>
                                )}
                                {report_type === 'percentile' && (
                                    <div>
                                        <b>Note : </b> {PERCENTILES}
                                    </div>
                                )}
                            </div>
                        )}
                    </Fragment>
                ) : null}
            </div>

            {surveyV ? (
                <ul className="fixedScoreCardOhi">
                    <div className="benchmark clearfix">
                        <li>{BENCHMARK_HEAD} : </li>
                        {quartileColors
                            .slice()
                            .reverse()
                            .map(({ title, background, border: borderColor }) => {
                                const bottomDecileVar = title === BOTTOM_DECILE;
                                const BenchmarkTitle = title === NO_BENCHMARK;
                                return (
                                    <li
                                        key={title}
                                        className={c({
                                            hide: bottomDecileVar || BenchmarkTitle,
                                        })}
                                    >
                                        <span
                                            className="benchmarkTriangle"
                                            style={{
                                                background,
                                                borderWidth: '13px 13px 0 0',
                                                borderColor: bottomDecileVar
                                                    ? `transparent ${borderColor} transparent transparent`
                                                    : `${borderColor} transparent transparent transparent`,
                                                borderStyle: 'solid',
                                            }}
                                        />
                                        <div style={{ color: 'black' }}>{title}</div>
                                    </li>
                                );
                            })}
                    </div>
                    <div className="bottomDetailContent">
                        <ul className="bottomList clearfix">
                            <li>{DIFF_HEAD} : </li>
                            {SIGNIFICANCES.map(({ title, bg: background }) => (
                                <li key={title}>
                                    <span style={{ background }} />
                                    {title}
                                </li>
                            ))}
                        </ul>
                    </div>
                </ul>
            ) : (
                <ul className="fixedScoreCardOhi">
                    <div className="benchmark clearfix">
                        <li>{BENCHMARK_HEAD} : </li>
                        {quartileColors.map(({ title, background, border: borderColor }) => (
                            <li key={title} style={{ color: background }}>
                                <span style={{ background, borderColor }} />
                                {title}
                            </li>
                        ))}
                    </div>
                    <div className="bottomDetailContent">
                        <ul className="bottomList clearfix">
                            <li>{DIFF_HEAD} : </li>
                            {SIGNIFICANCES.map(({ title, bg: background }) => (
                                <li key={title}>
                                    <span style={{ background }} />
                                    {title}
                                </li>
                            ))}
                        </ul>
                    </div>
                </ul>
            )}
        </>
    );
}

BUDetailedReport.propTypes = {
    errorInfo: PropTypes.string.isRequired,
    scoreData: PropTypes.object.isRequired,
    defaultSettings: PropTypes.object.isRequired,
    setReport: PropTypes.func.isRequired,
    activeResetFilter: PropTypes.bool.isRequired,
    updateFilterView: PropTypes.func.isRequired,
    appliedFiltersInfo: PropTypes.func.isRequired,
    localPractice: PropTypes.string.isRequired,
    filters: PropTypes.array.isRequired,
    buFilters: PropTypes.array.isRequired,
    apiParams: PropTypes.object.isRequired,
    getReport: PropTypes.func.isRequired,
    getRawPptData: PropTypes.func.isRequired,
    getSinglePastReport: PropTypes.func.isRequired,
    singlePastReport: PropTypes.object.isRequired,
    reportError: PropTypes.string.isRequired,
    isEntireOrganizationSelected: PropTypes.bool,
};

BUDetailedReport.defaultProps = {
    isEntireOrganizationSelected: false,
};

export default BUDetailedReport;
